
define('text!views/merchants/gmap.html',[],function () { return '<div class="mapContainer"></div>';});

